import React, { useRef } from "react";
import css from "./LikeAnimWrapper.module.scss";

type Props = {
  children: React.ReactNode;
  animFlag: number | null;
};

const LikeAnimWrapper = ({ children, animFlag, ...rest }: Props) => {
  const [startAnim, setstartAnim] = React.useState(false);
  const animDuration = 400;

  React.useEffect(() => {
    if (!animFlag) return;

    const animationStart = () => {
      if (startAnim) {
        return;
      }
      setstartAnim(true);

      // 連続でアニメーションされないようにする
      setTimeout(() => {
        setstartAnim(false);
      }, animDuration);
    };

    animationStart();
  }, [animFlag]);

  return (
    <div
      className={`
      ${css["comp"]}
      ${startAnim && css["m-animating"]}
      `}
    >
      <div
        className={css["animWrap"]}
        style={{
          animationDuration: `${animDuration}ms`,
        }}
      >
        {dotStyles.map((dotStyle, index) => {
          const { size, ...rest } = dotStyle;
          return (
            <div
              key={index}
              className={css["dot"]}
              style={{
                width: dotStyle.size,
                height: dotStyle.size,
                animationDuration: `${animDuration - 150}ms`,
                ...rest,
              }}
            ></div>
          );
        })}
      </div>
      {children}
    </div>
  );
};

const dotStyles = [
  {
    backgroundColor: "#9500f7",
    size: "3px",
    top: "-5px",
    left: "10px",
  },
  {
    backgroundColor: "#9500f7",
    size: "4px",
    top: "1px",
    left: "-6px",
  },
  {
    backgroundColor: "#009eff",
    size: "3px",
    top: "20px",
    left: "-8px",
  },
  {
    backgroundColor: "#ffef00",
    size: "2px",
    bottom: "10px",
    left: "0px",
  },
  {
    backgroundColor: "#9500f7",
    size: "3px",
    bottom: "0px",
    left: "0px",
  },
  {
    backgroundColor: "#8CE8C3",
    size: "4px",
    top: "-6px",
    right: "6px",
  },
  {
    backgroundColor: "#ffef00",
    size: "3px",
    top: "4px",
    right: "-4px",
  },
  {
    backgroundColor: "#009eff",
    size: "3px",
    top: "14px",
    right: "-10px",
  },
  {
    backgroundColor: "#009eff",
    size: "2px",
    bottom: "8px",
    right: "0px",
  },
  {
    backgroundColor: "#ffef00",
    size: "2px",
    bottom: "1px",
    right: "8px",
  },
];

export default LikeAnimWrapper;
